import React from 'react'
import { FieldValues, UseFormRegister, UseFormWatch } from 'react-hook-form'
import { InvoiceDetail } from 'src/features/pending-receivements/PendingReceivementsTypes'
import { EditQtyPerBoxField } from '../EditQtyPerBoxModal.style'
import * as S from './InvoiceItemRow.style'

export const InvoiceItemRow = (invoiceDetail: InvoiceDetail, index: number, register: UseFormRegister<FieldValues>, watch: UseFormWatch<FieldValues>) => ({
  idAr: invoiceDetail.idAr,
  qtyPerBoxInput: (
    <S.Container>
      <EditQtyPerBoxField
        {...register(`qty-per-box-row-${index}`, {
          required: true,
          value: invoiceDetail.qtyPerBox,
          valueAsNumber: true,
          min: 1,
        })}
        key={index}
        variant='outlined'
        size='small'
        inputProps={{
          style: {
            textAlign: 'center',
            height: '16px',
            padding: '8px',
          },
          'data-testid': 'edit-qty-per-box-field',
        }}
        autoComplete='off'
        onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
      />
      {`${invoiceDetail.measureUnit}`}
    </S.Container>
  ),
  boxQuantity: invoiceDetail.boxQuantity,
  expectedQuantity: `${((watch(`qty-per-box-row-${index}`) ?? invoiceDetail.qtyPerBox) * invoiceDetail.boxQuantity) || '-'} ${invoiceDetail.measureUnit}`,
})
